import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { space } from '@guardian/src-foundations';
import { headline } from '@guardian/src-foundations/typography';
import { decidePalette } from '@root/src/web/lib/decidePalette';
const thinGreySolid = (palette) => `1px solid ${palette.border.matchTab}`;
const GreyBorder = ({ palette }) => (_jsx("div", { css: css `
			border-left: ${thinGreySolid(palette)};
			margin-left: ${space[1]}px;
			width: ${space[2]}px;
		` }, void 0));
const tabsContainer = (palette) => css `
	display: flex;
	position: relative;
	border-bottom: ${thinGreySolid(palette)};
`;
const tab = (palette) => css `
	flex-basis: 50%;
	height: 40px;
	border-top: 3px solid ${palette.border.matchTab};

	:nth-child(1) {
		border-top: 3px solid ${palette.border.activeMatchTab};
	}
`;
const tabLink = (palette) => css `
	color: ${palette.border.activeMatchTab};
	display: block;
	text-decoration: none;
	&:hover {
		background-color: ${palette.background.article};
	}
`;
const tabLabel = css `
	${headline.xxxsmall()};
	background: transparent;
	padding: 6px 8px 0;
	text-align: left;
	font-weight: 600;
	min-height: 36px;
	display: block;
	width: 100%;
`;
export const MatchTabs = ({ minByMinUrl, reportUrl, format }) => {
    const palette = decidePalette(format);
    return (_jsx("div", { children: _jsxs("ul", Object.assign({ css: tabsContainer(palette) }, { children: [_jsx("li", Object.assign({ css: tab(palette) }, { children: _jsx("a", Object.assign({ href: reportUrl, "data-link-name": "report", css: tabLink(palette) }, { children: _jsx("span", Object.assign({ css: tabLabel }, { children: "Report" }), void 0) }), void 0) }), void 0), _jsx(GreyBorder, { palette: palette }, void 0), _jsx("li", Object.assign({ css: tab(palette) }, { children: _jsx("a", Object.assign({ href: minByMinUrl, "data-link-name": "Min-by-min", css: tabLink(palette) }, { children: _jsx("span", Object.assign({ css: tabLabel }, { children: "Min-by-min" }), void 0) }), void 0) }), void 0)] }), void 0) }, void 0));
};
